// import { useState } from 'react';
// import { Card, CardBody, CardExpandToggler } from '@components/card/card.jsx';
// import Loading from '@components/Shared/Loader/Loading';
// import { useTranslation } from 'react-i18next';
// import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
// import ReactApexChart from 'react-apexcharts';

// import { ChevronRight, ChevronLeft } from 'lucide-react';
// import Bar from '../../dashboard/Bar.jsx';
// import Pie from '../../dashboard/Pie.jsx';
// import Breadcrumb from '@components/Shared/Breadcrumb';

// const InvDashboard = () => {
//   const [moduleId, setModuleId] = useState('0a6c6b89-1d52-4eaa-8d2c-010c74b1f6e0'); // الموارد البشرية افتراضي

//   const { i18n } = useTranslation();

//   const { data, loading } = useGetInventoryWithPermission();

//   const InventoryList = [
//     {
//       id: null,
//       name2: 'كل المخازن',
//       name: 'All Inventories'
//     },
//     ...data
//   ];

//   const handleScroll = (direction: any) => {
//     const container = document.getElementById('module-nav');
//     const scrollAmount = 300;
//     if (container) {
//       container.scrollBy({
//         left: direction === 'right' ? scrollAmount : -scrollAmount,
//         behavior: 'smooth'
//       });
//     }
//   };

//   //~~~~~~~~~~~~~~~~~~~~~~~~~~~
//   const [pieChartData, setPieChartData] = useState({
//     labels: ['إلكترونيات', 'أدوات منزلية', 'ملابس', 'أغذية'],
//     series: [35, 25, 20, 20] // النسب المئوية لكل تصنيف
//   });

//   const [barChartData, setBarChartData] = useState({
//     options: {
//       chart: {
//         type: 'bar',
//         stacked: true
//       },
//       xaxis: {
//         categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو']
//       },
//       title: {
//         text: 'حركة المخزون حسب الأشهر',
//         align: 'center'
//       },
//       colors: ['#34c38f', '#f46a6a']
//     },
//     series: [
//       {
//         name: 'الكميات المضافة',
//         data: [500, 400, 600, 800, 700, 900]
//       },
//       {
//         name: 'الكميات المستخدمة',
//         data: [300, 200, 400, 600, 500, 700]
//       }
//     ]
//   });

//   const [barChartData2, setBarChartData2] = useState({
//     title: 'حركة المخزون حسب الأشهر',

//     categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو'],

//     series: [
//       {
//         name: 'الكميات المضافة',
//         data: [500, 400, 600, 800, 700, 900]
//       },
//       {
//         name: 'الكميات المستخدمة',
//         data: [300, 200, 400, 600, 500, 700]
//       }
//     ]
//   });

//   const lowStockItems = [
//     { name: 'هاتف سامسونج A54', category: 'إلكترونيات', quantity: 5, minQuantity: 10 },
//     { name: 'تيشيرت بولو رجالي', category: 'ملابس', quantity: 3, minQuantity: 5 },
//     { name: 'علبة حليب مجفف نيدو', category: 'أغذية', quantity: 2, minQuantity: 4 },
//     { name: 'دفتر 200 ورقة', category: 'أدوات مكتبية', quantity: 7, minQuantity: 15 },
//     { name: 'سائل تنظيف صحون فيري', category: 'مواد تنظيف', quantity: 6, minQuantity: 8 },
//     { name: 'سماعات بلوتوث JBL', category: 'إلكترونيات', quantity: 1, minQuantity: 3 },
//     { name: 'زيت دوار الشمس عافية', category: 'أغذية', quantity: 4, minQuantity: 10 },
//     { name: 'بنطال جينز لي', category: 'ملابس', quantity: 2, minQuantity: 6 },
//     { name: 'طقم أكواب زجاجية', category: 'أدوات منزلية', quantity: 3, minQuantity: 7 },
//     { name: 'ساعة يد كاسيو', category: 'إكسسوارات', quantity: 5, minQuantity: 10 }
//   ];

//   const [radarChartData, setRadarChartData] = useState({
//     options: {
//       chart: {
//         type: 'radar'
//       },
//       xaxis: {
//         categories: ['مستودع 1', 'مستودع 2', 'مستودع 3', 'مستودع 4']
//       },
//       title: {
//         text: 'توزيع الأصناف حسب المستودعات',
//         align: 'center'
//       },
//       colors: ['#34c38f', '#008ffb']
//     },
//     series: [
//       {
//         name: 'الإلكترونيات',
//         data: [100, 200, 150, 180]
//       },
//       {
//         name: 'الأدوات المنزلية',
//         data: [120, 250, 200, 100]
//       }
//     ]
//   });

//   const [chartData, setChartData] = useState({
//     options: {
//       chart: {
//         type: 'bar'
//       },
//       title: {
//         text: 'الأصناف الأكثر تداولًا',
//         align: 'center'
//       },
//       plotOptions: {
//         bar: {
//           horizontal: true,
//           barHeight: '70%'
//         }
//       },
//       xaxis: {
//         categories: ['الصنف 1', 'الصنف 2', 'الصنف 3', 'الصنف 4', 'الصنف 5'],
//         title: {
//           text: 'عدد العمليات'
//         }
//       },
//       colors: ['#34c38f']
//     },
//     series: [
//       {
//         name: 'عدد العمليات',
//         data: [120, 100, 80, 60, 40] // بيانات عدد العمليات لكل صنف
//       }
//     ]
//   });
//   const [chartData2, setChartData2] = useState({
//     title: 'الأصناف الأكثر تداولًا',
//     categories: ['الصنف 1', 'الصنف 2', 'الصنف 3', 'الصنف 4', 'الصنف 5'],

//     series: [
//       {
//         name: 'عدد العمليات',
//         data: [120, 100, 80, 60, 40] // بيانات عدد العمليات لكل صنف
//       }
//     ]
//   });

//   return (
//     <>
//       <Breadcrumb
//         BreadcrumbList={[
//           {
//             name: 'Home',
//             link: null
//           }
//         ]}
//       />

//       <Loading loading={loading}>
//         <Card className='mb-3'>
//           <CardBody className='p-0'>
//             <div className='position-relative'>
//               <button
//                 className='btn btn-icon btn-theme position-absolute start-0 top-50 translate-middle-y z-1 ms-2'
//                 onClick={() => handleScroll('left')}
//               >
//                 <ChevronLeft size={20} />
//               </button>

//               <div
//                 id='module-nav'
//                 className='scroll-wrapper'
//                 style={{
//                   overflowX: 'hidden',
//                   margin: '0 40px',
//                   WebkitMaskImage: 'linear-gradient(to right, transparent, black 20px, black 95%, transparent)'
//                 }}
//               >
//                 <div className='d-flex gap-2 py-3 px-2'>
//                   {InventoryList?.map(inv => (
//                     <button
//                       key={inv.id}
//                       onClick={() => setModuleId(inv.id)}
//                       className={`btn ${
//                         moduleId === inv.id ? 'btn-theme' : 'btn-default'
//                       } d-flex flex-fill align-items-center gap-2 px-3 py-2`}
//                       style={{ whiteSpace: 'nowrap', transition: 'all 0.2s' }}
//                     >
//                       {/* <module.icon size={18} /> */}
//                       <span>{i18n.language === 'en' ? inv.name : inv.name2}</span>
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <button
//                 className='btn btn-icon btn-theme position-absolute end-0 top-50 translate-middle-y z-1 me-2'
//                 onClick={() => handleScroll('right')}
//               >
//                 <ChevronRight size={20} />
//               </button>
//             </div>
//           </CardBody>
//         </Card>

//         <div className='row g-3'>
//           <div className='col-12 col-md-6 col-lg-6'>
//             <Card className='mb-3' style={{ height: '100%' }}>
//               <CardBody>
//                 <div className='d-flex fw-bold small mb-3'>
//                   <span className='flex-grow-1 fs-6 fw-bold'>الأصناف القريبة من النفاد</span>
//                   <CardExpandToggler />
//                 </div>
//                 {/* <div className="ratio ratio-21x9 mb-3"> */}
//                 <div className='table-responsive'>
//                   <table className='table table-hover'>
//                     <thead className='bg-theme bg-opacity-30'>
//                       <tr>
//                         <th>اسم المنتج</th>
//                         <th>التصنيف</th>
//                         <th>الكمية المتوفرة</th>
//                         <th>الحد الأدنى</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {lowStockItems.map((item, index) => (
//                         <tr key={index}>
//                           <td className='align-middle'>{item.name}</td>
//                           <td className='align-middle'>{item.category}</td>
//                           <td className='align-middle'>{item.quantity}</td>
//                           <td className='align-middle'>{item.minQuantity}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//                 {/* </div> */}
//               </CardBody>
//             </Card>
//           </div>

//           <div className='col-12 col-md-6 col-lg-6'>
//             <Card className='mb-3' style={{ height: '100%' }}>
//               <CardBody>
//                 <div className='d-flex fw-bold small mb-3'>
//                   <span className='flex-grow-1 fs-6 fw-bold'>حركة المخزون حسب الأشهر</span>
//                   <CardExpandToggler />
//                 </div>

//                 <Bar
//                   categories={barChartData2.categories}
//                   series={barChartData2.series}
//                   height={400}
//                   isStacked={true}
//                 />
//               </CardBody>
//             </Card>
//           </div>

//           <div className='col-12 col-md-6 col-lg-4'>
//             <Card className='mb-3' style={{ height: '100%' }}>
//               <CardBody>
//                 <div className='d-flex fw-bold small mb-3'>
//                   <span className='flex-grow-1 fs-6 fw-bold'>الأصناف الأكثر تداولًا:</span>
//                   <CardExpandToggler />
//                 </div>

//                 <Bar categories={chartData2.categories} series={chartData2.series} height={400} isHorizontal={true} />
//               </CardBody>
//             </Card>
//           </div>
//           <div className='col-12 col-md-6 col-lg-4'>
//             <Card className='mb-3' style={{ height: '100%' }}>
//               <CardBody>
//                 <div className='d-flex fw-bold small mb-3'>
//                   <span className='flex-grow-1 fs-6 fw-bold'>توزيع الكميات حسب التصنيفات</span>
//                   <CardExpandToggler />
//                 </div>

//                 <Pie labels={pieChartData.labels} series={pieChartData.series} height={400} />

//                 {/* </div> */}
//               </CardBody>
//             </Card>
//           </div>

//           <div className='col-12 col-md-6 col-lg-4'>
//             <Card className='mb-3' style={{ height: '100%' }}>
//               <CardBody>
//                 <div className='d-flex fw-bold small mb-3'>
//                   <span className='flex-grow-1 fs-6 fw-bold'></span>
//                   <CardExpandToggler />
//                 </div>
//                 {/* <div className="ratio ratio-21x9 mb-3"> */}
//                 {/* مخطط راداري (Radar Chart) لتوزيع الأصناف حسب المستودعات/ */}

//                 <ReactApexChart
//                   options={radarChartData.options}
//                   series={radarChartData.series}
//                   type='radar'
//                   height={350}
//                 />

//                 {/* </div> */}
//               </CardBody>
//             </Card>
//           </div>
//         </div>
//       </Loading>
//     </>
//   );
// };

// export default InvDashboard;

import { useState } from 'react';
import { Card, CardBody, CardExpandToggler } from '@components/card/card.jsx';
import Loading from '@components/Shared/Loader/Loading';
import { useTranslation } from 'react-i18next';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import ReactApexChart from 'react-apexcharts';

import { ChevronRight, ChevronLeft } from 'lucide-react';
import Bar from '../../dashboard/Bar.jsx';
import Pie from '../../dashboard/Pie.jsx';
import Breadcrumb from '@components/Shared/Breadcrumb';

const InvDashboard = () => {
  const [moduleId, setModuleId] = useState('0a6c6b89-1d52-4eaa-8d2c-010c74b1f6e0'); // الموارد البشرية افتراضي
  const { i18n } = useTranslation();
  const { data, loading } = useGetInventoryWithPermission();

  const InventoryList = [{ id: null, name2: 'كل المخازن', name: 'All Inventories' }, ...data];

  const handleScroll = (direction: any) => {
    const container = document.getElementById('module-nav');
    const scrollAmount = 300;
    if (container) {
      container.scrollBy({
        left: direction === 'right' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  // بيانات المخططات والجدول ثنائية اللغة
  const [pieChartData] = useState({
    labels:
      i18n.language === 'en'
        ? ['Electronics', 'Home Appliances', 'Clothes', 'Food']
        : ['إلكترونيات', 'أدوات منزلية', 'ملابس', 'أغذية'],
    series: [35, 25, 20, 20]
  });

  const [barChartData2] = useState({
    title: i18n.language === 'en' ? 'Inventory Movement by Months' : 'حركة المخزون حسب الأشهر',
    categories:
      i18n.language === 'en'
        ? ['January', 'February', 'March', 'April', 'May', 'June']
        : ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو'],
    series: [
      { name: i18n.language === 'en' ? 'Added Quantity' : 'الكميات المضافة', data: [500, 400, 600, 800, 700, 900] },
      { name: i18n.language === 'en' ? 'Used Quantity' : 'الكميات المستخدمة', data: [300, 200, 400, 600, 500, 700] }
    ]
  });

  const [chartData2] = useState({
    title: i18n.language === 'en' ? 'Most Used Items' : 'الأصناف الأكثر تداولًا',
    categories:
      i18n.language === 'en'
        ? ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5']
        : ['الصنف 1', 'الصنف 2', 'الصنف 3', 'الصنف 4', 'الصنف 5'],
    series: [{ name: i18n.language === 'en' ? 'Operations Count' : 'عدد العمليات', data: [120, 100, 80, 60, 40] }]
  });

  const [radarChartData] = useState({
    options: {
      chart: { type: 'radar' },
      xaxis: {
        categories:
          i18n.language === 'en'
            ? ['Warehouse 1', 'Warehouse 2', 'Warehouse 3', 'Warehouse 4']
            : ['مستودع 1', 'مستودع 2', 'مستودع 3', 'مستودع 4']
      },
      title: {
        text: i18n.language === 'en' ? 'Items Distribution by Warehouses' : 'توزيع الأصناف حسب المستودعات',
        align: 'center'
      },
      colors: ['#34c38f', '#008ffb']
    },
    series: [
      { name: i18n.language === 'en' ? 'Electronics' : 'الإلكترونيات', data: [100, 200, 150, 180] },
      { name: i18n.language === 'en' ? 'Home Appliances' : 'الأدوات المنزلية', data: [120, 250, 200, 100] }
    ]
  });

  // const lowStockItems = [
  //   { name: 'هاتف سامسونج A54', category: i18n.language === 'en' ? 'Electronics' : 'إلكترونيات', quantity: 5, minQuantity: 10 },
  //   { name: 'تيشيرت بولو رجالي', category: i18n.language === 'en' ? 'Clothes' : 'ملابس', quantity: 3, minQuantity: 5 },
  //   { name: 'علبة حليب مجفف نيدو', category: i18n.language === 'en' ? 'Food' : 'أغذية', quantity: 2, minQuantity: 4 },
  //   { name: 'دفتر 200 ورقة', category: i18n.language === 'en' ? 'Stationery' : 'أدوات مكتبية', quantity: 7, minQuantity: 15 },
  //   { name: 'سائل تنظيف صحون فيري', category: i18n.language === 'en' ? 'Cleaning Supplies' : 'مواد تنظيف', quantity: 6, minQuantity: 8 },
  //   { name: 'سماعات بلوتوث JBL', category: i18n.language === 'en' ? 'Electronics' : 'إلكترونيات', quantity: 1, minQuantity: 3 },
  //   { name: 'زيت دوار الشمس عافية', category: i18n.language === 'en' ? 'Food' : 'أغذية', quantity: 4, minQuantity: 10 },
  //   { name: 'بنطال جينز لي', category: i18n.language === 'en' ? 'Clothes' : 'ملابس', quantity: 2, minQuantity: 6 },
  //   { name: 'طقم أكواب زجاجية', category: i18n.language === 'en' ? 'Home Appliances' : 'أدوات منزلية', quantity: 3, minQuantity: 7 },
  //   { name: 'ساعة يد كاسيو', category: i18n.language === 'en' ? 'Accessories' : 'إكسسوارات', quantity: 5, minQuantity: 10 }
  // ];

  const lowStockItems = [
    {
      name: i18n.language === 'en' ? 'Car Air Filter' : 'فلتر هواء سيارة',
      category: i18n.language === 'en' ? 'Spare Parts' : 'قطع غيار',
      quantity: 8,
      minQuantity: 20
    },
    {
      name: i18n.language === 'en' ? 'Brake Pads Set' : 'طقم فحمات فرامل',
      category: i18n.language === 'en' ? 'Spare Parts' : 'قطع غيار',
      quantity: 5,
      minQuantity: 15
    },
    {
      name: i18n.language === 'en' ? 'Spark Plugs' : 'شمعات إشعال',
      category: i18n.language === 'en' ? 'Spare Parts' : 'قطع غيار',
      quantity: 12,
      minQuantity: 30
    },
    {
      name: i18n.language === 'en' ? 'Car Battery 12V' : 'بطارية سيارة 12 فولت',
      category: i18n.language === 'en' ? 'Spare Parts' : 'قطع غيار',
      quantity: 3,
      minQuantity: 10
    },
    {
      name: i18n.language === 'en' ? 'Oil Filter' : 'فلتر زيت',
      category: i18n.language === 'en' ? 'Spare Parts' : 'قطع غيار',
      quantity: 6,
      minQuantity: 15
    },
    {
      name: i18n.language === 'en' ? 'Alternator Belt' : 'سير دينمو',
      category: i18n.language === 'en' ? 'Spare Parts' : 'قطع غيار',
      quantity: 4,
      minQuantity: 12
    },
    {
      name: i18n.language === 'en' ? 'Radiator Hose' : 'خرطوم رديتر',
      category: i18n.language === 'en' ? 'Spare Parts' : 'قطع غيار',
      quantity: 7,
      minQuantity: 18
    }
  ];

  return (
    <>
      <Breadcrumb BreadcrumbList={[{ name: i18n.language === 'en' ? 'Home' : 'الرئيسية', link: null }]} />

      <Loading loading={loading}>
        <Card className='mb-3'>
          <CardBody className='p-0'>
            <div className='position-relative'>
              <button
                className='btn btn-icon btn-theme position-absolute start-0 top-50 translate-middle-y z-1 ms-2'
                onClick={() => handleScroll('left')}
              >
                <ChevronLeft size={20} />
              </button>

              <div
                id='module-nav'
                className='scroll-wrapper'
                style={{
                  overflowX: 'hidden',
                  margin: '0 40px',
                  WebkitMaskImage: 'linear-gradient(to right, transparent, black 20px, black 95%, transparent)'
                }}
              >
                <div className='d-flex gap-2 py-3 px-2'>
                  {InventoryList?.map(inv => (
                    <button
                      key={inv.id}
                      onClick={() => setModuleId(inv.id)}
                      className={`btn ${
                        moduleId === inv.id ? 'btn-theme' : 'btn-default'
                      } d-flex flex-fill align-items-center gap-2 px-3 py-2`}
                      style={{ whiteSpace: 'nowrap', transition: 'all 0.2s' }}
                    >
                      <span>{i18n.language === 'en' ? inv.name : inv.name2}</span>
                    </button>
                  ))}
                </div>
              </div>

              <button
                className='btn btn-icon btn-theme position-absolute end-0 top-50 translate-middle-y z-1 me-2'
                onClick={() => handleScroll('right')}
              >
                <ChevronRight size={20} />
              </button>
            </div>
          </CardBody>
        </Card>

        <div className='row g-3'>
          {/* الأصناف القريبة من النفاد */}
          <div className='col-12 col-md-6 col-lg-6'>
            <Card className='mb-3' style={{ height: '100%' }}>
              <CardBody>
                <div className='d-flex fw-bold small mb-3'>
                  <span className='flex-grow-1 fs-6 fw-bold'>
                    {i18n.language === 'en' ? 'Low Stock Items' : 'الأصناف القريبة من النفاد'}
                  </span>
                  <CardExpandToggler />
                </div>
                <div className='table-responsive'>
                  <table className='table table-hover'>
                    <thead className='bg-theme bg-opacity-30'>
                      <tr>
                        <th>{i18n.language === 'en' ? 'Product Name' : 'اسم المنتج'}</th>
                        <th>{i18n.language === 'en' ? 'Category' : 'التصنيف'}</th>
                        <th>{i18n.language === 'en' ? 'Available Quantity' : 'الكمية المتوفرة'}</th>
                        <th>{i18n.language === 'en' ? 'Minimum Quantity' : 'الحد الأدنى'}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lowStockItems.map((item, index) => (
                        <tr key={index}>
                          <td className='align-middle'>{item.name}</td>
                          <td className='align-middle'>{item.category}</td>
                          <td className='align-middle'>{item.quantity}</td>
                          <td className='align-middle'>{item.minQuantity}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </div>

          {/* حركة المخزون حسب الأشهر */}
          <div className='col-12 col-md-6 col-lg-6'>
            <Card className='mb-3' style={{ height: '100%' }}>
              <CardBody>
                <div className='d-flex fw-bold small mb-3'>
                  <span className='flex-grow-1 fs-6 fw-bold'>{barChartData2.title}</span>
                  <CardExpandToggler />
                </div>
                <Bar
                  categories={barChartData2.categories}
                  series={barChartData2.series}
                  height={400}
                  isStacked={true}
                />
              </CardBody>
            </Card>
          </div>

          {/* الأصناف الأكثر تداولًا */}
          <div className='col-12 col-md-6 col-lg-4'>
            <Card className='mb-3' style={{ height: '100%' }}>
              <CardBody>
                <div className='d-flex fw-bold small mb-3'>
                  <span className='flex-grow-1 fs-6 fw-bold'>{chartData2.title}</span>
                  <CardExpandToggler />
                </div>
                <Bar categories={chartData2.categories} series={chartData2.series} height={400} isHorizontal={true} />
              </CardBody>
            </Card>
          </div>

          {/* توزيع الكميات حسب التصنيفات */}
          <div className='col-12 col-md-6 col-lg-4'>
            <Card className='mb-3' style={{ height: '100%' }}>
              <CardBody>
                <div className='d-flex fw-bold small mb-3'>
                  <span className='flex-grow-1 fs-6 fw-bold'>
                    {i18n.language === 'en' ? 'Distribution by Categories' : 'توزيع الكميات حسب التصنيفات'}
                  </span>
                  <CardExpandToggler />
                </div>
                <Pie labels={pieChartData.labels} series={pieChartData.series} height={400} />
              </CardBody>
            </Card>
          </div>

          {/* مخطط راداري */}
          {/* <div className='col-12 col-md-6 col-lg-4'>
            <Card className='mb-3' style={{ height: '100%' }}>
              <CardBody>
                <div className='d-flex fw-bold small mb-3'>
                  <span className='flex-grow-1 fs-6 fw-bold'>
                    {radarChartData.options.title.text}
                  </span>
                  <CardExpandToggler />
                </div>
                <ReactApexChart options={radarChartData.options} series={radarChartData.series} type='radar' height={350} />
              </CardBody>
            </Card>
          </div> */}
        </div>
      </Loading>
    </>
  );
};

export default InvDashboard;
